<p>mon-quotidien works!</p>
